var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg18086593911556105312(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.61 23.01l-10.45-4.79c-.214-.098-.214-.259 0-.357l10.45-4.79c.214-.098.566-.098.78 0l10.45 4.79c.214.098.214.26 0 .358L24.39 23.01a1.07 1.07 0 01-.78 0zm11.23.683l-2.504-1.143a1.073 1.073 0 00-.78 0l-7.166 3.272a1.073 1.073 0 01-.78 0l-7.166-3.272a1.073 1.073 0 00-.78 0l-2.503 1.143c-.215.098-.215.258 0 .356L23.61 28.82c.214.098.566.098.78 0l10.45-4.77c.214-.099.214-.259 0-.357zm0 6.106l-2.504-1.142a1.073 1.073 0 00-.78 0l-7.166 3.272a1.074 1.074 0 01-.78 0l-7.166-3.272a1.073 1.073 0 00-.78 0l-2.503 1.142c-.215.099-.215.259 0 .357l10.449 4.77c.214.099.566.099.78 0l10.45-4.77c.214-.098.214-.258 0-.357z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18086593911556105312);
export default __webpack_public_path__ + "static/media/18086593911556105312.eff1c9155218e7dd36329e79ba8d2549.svg";
export { ForwardRef as ReactComponent };